import React from 'react';
import { mvpFeatures } from '@/content/mvp';
import { cn } from '@/lib/utils';
import { BrainCircuit, ScrollText, Code2, Activity, PlayCircle, FileArchive } from 'lucide-react';

const iconMap: Record<string, React.ReactNode> = {
    'ai-chat': <BrainCircuit className="h-6 w-6" />,
    'prompt-logging': <ScrollText className="h-6 w-6" />,
    'collab-editor': <Code2 className="h-6 w-6" />,
    'timeline': <Activity className="h-6 w-6" />,
    'replay': <PlayCircle className="h-6 w-6" />,
    'export': <FileArchive className="h-6 w-6" />
};

export function FeatureGrid({ className }: { className?: string }) {
    return (
        <section className={cn('mx-auto max-w-6xl px-4 py-16', className)} id="features">
            <div className="mb-12 text-center">
                <h2 className="text-3xl font-bold tracking-tight sm:text-4xl">Asynchronous, task-based technical interviews</h2>
                <p className="mt-3 text-muted-foreground max-w-2xl mx-auto">
                    Candidates complete interviews on their own time. Every prompt, code change, and key moment is captured for rich post-session review—so teams can focus on signal, not scheduling.
                </p>
            </div>
            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-2">
                {mvpFeatures.map(f => (
                    <div key={f.key} className="group relative rounded-xl border bg-card p-5 shadow-sm transition hover:shadow-md">
                        <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 text-primary group-hover:bg-primary/15">
                            {iconMap[f.key]}
                        </div>
                        <h3 className="text-lg font-semibold leading-snug">{f.title}</h3>
                        <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{f.description}</p>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default FeatureGrid;
